import React from "react";
import './addToBox.style.scss';
import { useDataLayer } from "../../../Contexts/DataLayer.context";

const AddToBox = ({ player, style, onClose }) => {
    const { listArray, updateListArray } = useDataLayer();

    const isPlayerInList = (listId) => {
        const list = listArray.find((listItem) => listItem.listId === listId);
        return list?.theNumbers.includes(player.FBXID) || false;
    };

    const handleAddRemoveClick = (listId) => {
        const updatedListArray = listArray.map((listItem) => {
            if (listItem.listId === listId) {
                const updatedNumbers = isPlayerInList(listId)
                    ? listItem.theNumbers.filter((num) => num !== player.FBXID)
                    : [...listItem.theNumbers, player.FBXID];

                return {
                    ...listItem,
                    theNumbers: updatedNumbers,
                    listTotal: updatedNumbers.length,
                };
            }
            return listItem;
        });
        updateListArray(updatedListArray);
    };

    return (
        <div className="add-to-box" style={style}>
            <div className="alert-navy p-2 text-center">
                <h5>{player.first} {player.last}</h5>
                <div className="fs-8 text-center">{player.colPos1} - {player.school}</div>
            </div>
            <div className="scrollable-list">
                {listArray.map((list) => (
                    <div className="listBoxDetail" key={list.listId}>
                        <div style={{ width: "15%" }}>
                            <button
                                className={`btn btn-sm text-white w-100 ${
                                    isPlayerInList(list.listId) ? 'btn-danger' : 'btn-success'
                                }`}
                                onClick={() => handleAddRemoveClick(list.listId)}
                            >
                                {isPlayerInList(list.listId) ? '-' : '+'}
                            </button>
                        </div>
                        <div className="text-start fs-7 px-2" style={{ width: "65%" }}>
                            {list.listName}
                        </div>
                        <div
                            className="text-center"
                            style={{
                                width: "15%",
                                backgroundColor: 'var(--light)',
                                fontSize: "12px",
                            }}
                        >
                            [{list.listTotal}]
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AddToBox;
